import { InputMenu } from '@/components/common/Input'
import { LinkHash } from '@/components/common/Link'
import { Icon } from '@/components/icons/Icon'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { type GalleryGroupType } from '@/defs/gallery'

import styles from './GalleryControlsJumpDropdown.module.scss'

type Props = {
  groups: GalleryGroupType[]
}

export const GalleryControlsJumpDropdown = ({ groups }: Props) => (
  <div className={styles.container}>
    <InputMenu
      aria-label='Jump to Section'
      options={groups.map((g) => ({
        label: (
          <LinkHash analyticsEvent={{ action: 'jumpto_click', category: 'cardlists', label: g.slug }} hash={g.slug}>
            <IconWithLabel iconBefore={g.icon} iconBeforeSize='sm' wrapNone>
              {g.label}
            </IconWithLabel>
          </LinkHash>
        ),
      }))}
    >
      <div className={styles.button}>
        <Icon name='caretDown' />
      </div>
    </InputMenu>
  </div>
)
